import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import ConsoleDemo from "../../../components/Home/Demo/ConsoleDemo";
import { AppCardProps } from "../../../components/common/AppCard/AppCard";
import RouterConstants from "../../../constants/RouterConstants";
import useSecureNavigate from "../../../hooks/useSecureNavigate";

const TgDemoTab = () => {
	const navigate = useSecureNavigate();
	const cards: AppCardProps[] = useMemo(
		() => [
			{
				card: "tailoredGeneration",
				onClick: () => navigate(RouterConstants.NEW_TG.DEMO.IMAGE_GENERATION.fullPath),
			},
		],
		[navigate],
	);

	return <ConsoleDemo cards={cards} />;
};

export default observer(TgDemoTab);
